import Vue from 'vue'
import './plugins/axios'
import App from './App.vue'
import router from './router'
import store from './store'
import './plugins/axios'
import './plugins/element'
import './permission'
import './styles/emoji.css'
import Timers from './utils/timer'
import net from './utils/ws'
import Event from './utils/event'
import request from '@/plugins/axios'
import 'overlayscrollbars/css/OverlayScrollbars.css'
import { OverlayScrollbarsComponent } from 'overlayscrollbars-vue'
import VueQuillEditor from 'vue-quill-editor'
import './assets/font/iconfont.css'
// 引入样式
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
Vue.use(VueQuillEditor)
Vue.component('overlay-scrollbars', OverlayScrollbarsComponent)
Vue.prototype.$net = net;
Vue.prototype.$event = Event;
Vue.prototype.$timer = Timers
Vue.prototype.$http = request
Vue.config.productionTip = false
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
